<template>
  <main class="app-viewport">
    <section class="app-shell" :class="{ 'app-shell--scroll': scrollable }">
      <slot />
    </section>
  </main>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    scrollable?: boolean
  }>(),
  {
    scrollable: false,
  },
)
</script>
